module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buchberg-9e1d494d7537343a10cc21726a16de71.png";